import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {
	types_all: ["purchaseReceive", "purchaseChangeSpecsReceive", "purchaseForceReceive", "purchaseChangeSpecsForceReceive", "purchaseRework",
		"returnBack", "returnBackRework", "inventoryRework", "manufactureReceive",
		"manufactureForceReceive",
		"manufactureRework",],

	// 2020-11-21
	search(params) {
		return axios.get('/qualities?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-11-21
	batchQuality(params) {
		return axios.put('/qualities/batch-quality', params)
	},
	// 2021-02-25
	batchQualityAndPush(params) {
		return axios.put('/qualities/batch-quality-and-push', params)
	},
	// 2020-11-21
	quality(id, params) {
		return axios.put('/qualities/' + id + '/quality', params)
	},
	// 2020-11-21
	rework(id, params) {
		return axios.put('/qualities/' + id + '/rework', params)
	},
	// 2020-11-21
	exportExcel(params) {
		return axios.get('/qualities/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2020-11-28
	unQualityCount(id, params) {
		return axios.get('/qualities/un-quality-count')
	},
}
